import React from 'react';
import PropTypes from 'prop-types';
import { useNeuroMessages, NeuroMessage } from '@ignitesales/neuro-application';

const ComparisonTable = ({ products = [] }) => {
    const { getMessage } = useNeuroMessages();
    const renderFeatures = productId => {
        const count = getMessage(`${productId}.features.table.content.count`);
        const features = Array(count)
            .fill(1)
            .map((v, index) => {
                const msgIndex = index + 1;
                const id = `${productId}.features.table.content.${msgIndex}`;
                return (<NeuroMessage id={id} tagName="li" />);
            });
        return features;
    };

    const productColumns = products.map(productId => {
        return (
            <div className="comparison-table--col">
                <div className="comparison-table--header-row">
                    <NeuroMessage id={`${productId}.features.table.name`} />
                </div>
                <div className="comparison-table--features-row">
                    <ul>
                        {renderFeatures(productId)}
                    </ul>
                </div>
            </div>)
    });
    return (
        <div className="comparison-table">
            { productColumns?.[0] }
            <div className="comparison-table--versus-col">
                <NeuroMessage id={'versus'} />
            </div>
            { productColumns?.[1] }
        </div>);
};



ComparisonTable.propTypes = {
    products: PropTypes.arrayOf({})
};

export default ComparisonTable;

